
const digest = '3da3cddbd664be5d1d9843f1f17e07fe13cc55bd3c1c648556b8abc35aec2d06';
const classes = {"wrapper":"_wrapper_18jsq_1","border":"_border_18jsq_4","content":"_content_18jsq_13","header":"_header_18jsq_18","openEntryName":"_openEntryName_18jsq_25","controls":"_controls_18jsq_36","cancelled":"_cancelled_18jsq_46","cancelledTitle":"_cancelledTitle_18jsq_50","cancelledTag":"_cancelledTag_18jsq_54","unclosedTag":"_unclosedTag_18jsq_59"};
const css = `._wrapper_18jsq_1 {
  background: #fff;
}
._wrapper_18jsq_1 ._border_18jsq_4 {
  display: flex;
  flex-direction: row;
  border: 1px solid #eaedf3;
  border-top: 0;
}
._wrapper_18jsq_1 ._border_18jsq_4:first-of-type {
  border-top: 1px solid #eaedf3;
}
._wrapper_18jsq_1 ._border_18jsq_4 ._content_18jsq_13 {
  flex: 1;
  display: flex;
  flex-direction: column;
}
._wrapper_18jsq_1 ._border_18jsq_4 ._content_18jsq_13 ._header_18jsq_18 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 12px;
  padding: 12px 0 0 0;
}
._wrapper_18jsq_1 ._border_18jsq_4 ._content_18jsq_13 ._header_18jsq_18 ._openEntryName_18jsq_25 {
  font-size: 16px;
  font-weight: 500;
  gap: 15px;
  display: flex;
  align-items: center;
}
._wrapper_18jsq_1 ._border_18jsq_4 ._content_18jsq_13 ._header_18jsq_18 ._openEntryName_18jsq_25 span {
  font-size: 12px;
  color: #ccc;
}
._wrapper_18jsq_1 ._border_18jsq_4 ._controls_18jsq_36 {
  padding: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 1px solid #eaedf3;
  gap: 15px;
  flex-direction: column;
}

._cancelled_18jsq_46 {
  color: #999999;
}

._cancelledTitle_18jsq_50 {
  text-decoration: line-through;
}

._cancelledTag_18jsq_54 {
  font-size: 60%;
  color: #000;
}

._unclosedTag_18jsq_59 {
  font-size: 60%;
  color: #fd7e31;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  